import { LoginService } from './auth/services/login.service';
/*
 * This file is part of the Intellija (R) product.
 * Copyright (c) 2020 IoTech LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import { NgModule } from '@angular/core';
import { Apollo, ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLinkModule, HttpLink } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ApolloLink, from, split } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { Router } from '@angular/router';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: [
    HttpClientModule,
    ApolloModule,
    HttpLinkModule
  ],
  providers: []
})
export class GraphQLModule {
  constructor(
    apollo: Apollo,
    httpLink: HttpLink,
    public router: Router,
    private loginService: LoginService
  ) {
    const uri: string = `${environment.BASE_URL + (environment.production || environment.staging ? 'gql/' : '')}v1/graphql`;
    // const uri: string = "http://localhost:8080/v1/graphql";
    const http = httpLink.create({
      uri
    });

    const authLink = new ApolloLink((operation, forward) => {
      const token = JSON.parse(localStorage.getItem('Token'))?.accessToken || '';
      operation.setContext({
          headers: {
              'Authorization': token ? `Bearer ${token}` : ''
          }
      });

      return forward(operation);
    });

    const errorLink = onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          ),
        );
      }

      if (networkError && networkError['status'] === 400) {
        this.loginService.logOut(true);
       }
    });

    // authLink.concat(errorLink);

    apollo.create({
      link: from([errorLink, authLink, http]),
      cache: new InMemoryCache({
        addTypename: false
      }),
      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'network-only',
          errorPolicy: 'all'
        },
        query: {
          fetchPolicy: 'network-only',
          errorPolicy: 'all',
        }
      }
    });
  }
}

